export const MarketingMediaTypesForDropdown = [
  {
    label: "Meta",
    value: "Meta",
  },
  {
    label: "Instagram",
    value: "Instagram",
  },
  {
    label: "LinkedIn",
    value: "LinkedIn",
  },
  {
    label: "YouTube",
    value: "YouTube",
  },
  {
    label: "Google Ads",
    value: "Google Ads",
  },
  {
    label: "TikTok",
    value: "TikTok",
  },
  {
    label: "SEO",
    value: "SEO",
  },
];
